export default [
  'fullscreen',
  'exit-fullscreen',
  'play',
  'pause',
  'replay',
  'standard-playbackrate',
  'forward',
  'backward',
  'prevframe',
  'nextframe',
  'annotations',
  'quality',
  'playback-rate',
  'settings',
  'buffering',
  'cc',
  'chapters',
  'back',
  'settings-fontcolor',
  'settings-fontsize',
  'settings-fontfamily',
  'settings-background',
  'settings-captionlocations',
  'help',
  'download',
  'video-only',
  'video-and',

  'monoserif',
  'propserif',
  'monosans',
  'propssans',

  'cc_location_over',
  'cc_location_below',

  'red',
  'purple',
  'indigo',
  'blue',
  'green',
  'yellow',
  'orange',
  'brown',
  'grey',
  'white',
  'black',

  'help-bacward',
  'help-play',
  'help-skip',
  'help-volume',
  'help-esc',

  'no-video',
  'playlist-count-of',
];
